import { UiPageTitle } from 'fitify-ui-onboarding/src/components/UiPageTitle'
import type { PageTitleProps } from 'fitify-ui-onboarding/src/types/pageTitle'

export function PageTitle(props: PageTitleProps) {
  return (
    <UiPageTitle
      {...props}
      suffix="Fitify"
      defaultOgImage="https://static.gofitify.com/images/og/fitify-digital-og-image.png"
    />
  )
}
